export default __webpack_public_path__ + "static/media/featured-item-5.d953501b.png";